import { Types } from "../actions/PlantActions";

const initialState = {
    plantList: {},
    plantloading: false,
    isTaskUpdatedPlant: false,
};

export const plantReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_PLANT_LIST:
            return {
                ...state,
                plantList: action.payload,
                plantloading: false,
            };
        case Types.IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdatedPlant: true,
            };
        case Types.RESET_IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdatedPlant: false,
            };
        default:
            return state;
    }
};
